import { AbstractControl, ValidationErrors } from '@angular/forms';

export function emailOrUsernameValidator(
  control: AbstractControl
): ValidationErrors | null {
  const value = control.value;

  if (!value) return { required: true };

  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  const usernameRegex = /^[a-zA-Z0-9_]{3,}$/;

  const isValidEmail = emailRegex.test(value);
  const isValidUsername = usernameRegex.test(value);

  return isValidEmail || isValidUsername ? null : { emailOrUsername: true };
}
